import React, { useState } from "react";
import logo from "../../resources/images/Logo.svg";
import logoDark from "../../resources/images/Logo_Dark.svg";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import "./Navbar.css";

const Navbar = () => {
  const location = useLocation();
  const isReachOutPage =
    location.pathname === "/reach-out" || location.pathname === "/join-us";

  const navigate = useNavigate();
  const [isMenuActive, setIsMenuActive] = useState(false);

  const handleMenuClick = () => {
    setIsMenuActive((prevState) => !prevState);
  };

  const handleNavigate = () => {
    // navigate("/");
    navigate("/find-talent");
  };
  return (
    <>
      <nav className="header_area">
        <div className="container">
          <div className=" header_bg d-flex align-items-center justify-content-between">
            <NavLink to="/" className="logo">
              <img
                src={isReachOutPage ? logoDark : logo}
                alt="logo"
                loading="lazy"
              />
            </NavLink>
            <nav
              className={`navbar ${isMenuActive ? "active" : ""} ${
                isReachOutPage ? "reach-nav" : ""
              }`}
            >
              <ul className="menu">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about-us">About us</NavLink>
                </li>
                <li>
                  <NavLink
                    to="https://clientapps.jobadder.com/99415/bravix"
                    target="_blank"
                  >
                    Open jobs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/join-us">join us</NavLink>
                </li>
                <li>
                  <NavLink to="/reach-out">contact us</NavLink>
                </li>
              </ul>
              <div className="log_infos d-block d-sm-none">
                <button
                  className={`find_talent_btn res_btn ${
                    isReachOutPage ? "reach-nav" : ""
                  }`}
                  onClick={handleNavigate}
                >
                  Find talent
                </button>
              </div>
            </nav>
            <div className="log_infos">
              <button
                className={`find_talent_btn ${
                  isReachOutPage ? "reach-nav" : ""
                }`}
                onClick={handleNavigate}
              >
                Find talent
              </button>
            </div>

            <div className="navbar_responsive">
              <div className="log_infos">
                <button
                  className={`find_talent_btn ${
                    isReachOutPage ? "reach-nav" : ""
                  }`}
                  onClick={handleNavigate}
                >
                  Find talent
                </button>
              </div>

              <div
                className={`show_menu ${isMenuActive ? "active" : ""} ${
                  isReachOutPage ? "reach-nav" : ""
                }`}
                onClick={handleMenuClick}
              >
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
